import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=96bd9a3c"
import script from "./wishlist.vue?vue&type=script&lang=js"
export * from "./wishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports